export const RESET_SVIETIMAS_STATE = 'RESET_SVIETIMAS_STATE';
export const SET_SVIETIMAS_ERROR = 'SET_SVIETIMAS_ERROR';
export const GET_SVIETIMAS_COURSES = 'GET_SVIETIMAS_COURSES';
export const SET_SVIETIMAS_COURSES = 'SET_SVIETIMAS_COURSES';
export const GET_SVIETIMAS_CHILDREN = 'GET_SVIETIMAS_CHILDREN';
export const SET_SVIETIMAS_CHILDREN = 'SET_SVIETIMAS_CHILDREN';
